import React from 'react'
import { Box, Flex } from 'reflexbox'
import classnames from 'classnames'

import LinkComponent from 'src/components/LinkComponent/LinkComponent'

import * as styles from './ButtonLink.module.scss'
import { Props } from './types'

const ButtonContent = ({ children }: Props): JSX.Element => (
  <Flex
    alignItems="center"
    paddingTop={[2, null, null, 2]}
    paddingBottom={[1, null, null, 1]}
  >
    <Box className={styles.text} textAlign="left">
      {children}
    </Box>
  </Flex>
)

const ButtonLink = ({
  onClick,
  to,
  title,
  children,
  className = '',
}: Props): JSX.Element => {
  const buttonStyles = classnames(styles.button, className)
  return onClick && !to ? (
    <Flex as="button" onClick={onClick} className={buttonStyles}>
      <ButtonContent>{children}</ButtonContent>
    </Flex>
  ) : to ? (
    <LinkComponent
      to={to}
      onClick={onClick}
      title={title}
      className={buttonStyles}
    >
      <ButtonContent>{children}</ButtonContent>
    </LinkComponent>
  ) : (
    <div />
  )
}

export default ButtonLink
